var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.625 4.125L13.16 11.6437C13.0415 13.5645 12.9823 14.5253 12.5 15.216C12.2619 15.5574 11.9554 15.8455 11.6 16.062C10.8822 16.5 9.92 16.5 7.9955 16.5C6.068 16.5 5.10425 16.5 4.385 16.0613C4.02942 15.8443 3.72291 15.5557 3.485 15.2137C3.0035 14.5222 2.945 13.56 2.8295 11.6363L2.375 4.125M1.25 4.125H14.75M11.042 4.125L10.5298 3.069C10.19 2.367 10.0198 2.01675 9.7265 1.79775C9.66136 1.74924 9.59238 1.70609 9.52025 1.66875C9.1955 1.5 8.8055 1.5 8.02625 1.5C7.22675 1.5 6.827 1.5 6.49625 1.6755C6.42314 1.71466 6.3534 1.75981 6.28775 1.8105C5.9915 2.03775 5.82575 2.4015 5.49425 3.12825L5.03975 4.125M6.125 12.375V7.875M9.875 12.375V7.875",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.157ca882ac6c760cc07ccd7170308612.svg";
export { ForwardRef as ReactComponent };